import { ComponentType } from 'react';
import { Tooltip, TooltipProps } from '../Tooltip';
import { Link } from '../Link';
import { Chip } from '../Chip';
import { Typography, TypographyProps } from '../Typography';

export type LinkChipProps = {
  href: string;
  label: string;
  tooltip?: string;
  typographyProps?: TypographyProps;
  tooltipPlacement?: TooltipProps['placement'];
  chipIcon?: ComponentType;
};

export const LinkChip = ({
  href,
  label,
  tooltip,
  typographyProps,
  tooltipPlacement,
  chipIcon: Icon,
}: LinkChipProps) => {
  const content = (
    <Link href={href} target='_blank' maxWidth='100%'>
      <Chip
        label={
          <Typography
            sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
            component='span'
            variant='inherit'
            {...typographyProps}
          >
            {label}
          </Typography>
        }
        component='span'
        clickable
        icon={Icon ? <Icon /> : undefined}
      />
    </Link>
  );

  if (tooltip === '') {
    return content;
  }

  return (
    <Tooltip title={tooltip || label} placement={tooltipPlacement || 'top'}>
      {content}
    </Tooltip>
  );
};
